import { render, staticRenderFns } from "./EditTranslation.vue?vue&type=template&id=49d4ab64&scoped=true&"
import script from "./EditTranslation.vue?vue&type=script&lang=js&"
export * from "./EditTranslation.vue?vue&type=script&lang=js&"
import style0 from "./EditTranslation.vue?vue&type=style&index=0&id=49d4ab64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4ab64",
  null
  
)

export default component.exports